export const LG = {
  color: {
    cream50: "#FBF6EC",
    cream100: "#F5EDE0",
    cream200: "#EFE3D0",
    cream300: "#E6D5BC",
    cream400: "#D9C2A2",
    cream: "#F5EDE0",
    creamLight: "#FBF6EC",
    text: "#0A0A0A",
    ink800: "#1B1815",
    ink700: "#2E2924",
    textSecondary: "#6B6259",
    textMuted: "#8E8479",
    textDisabled: "#B4ABA0",
    surface: "rgba(255, 250, 240, 0.55)",
    surfaceHover: "rgba(255, 250, 240, 0.6)",
    surfaceStrong: "rgba(255, 250, 240, 0.78)",
    surfaceDark: "rgba(20, 16, 12, 0.55)",
    border: "rgba(255, 255, 255, 0.55)",
    borderStrong: "rgba(255, 255, 255, 0.6)",
    divider: "rgba(10, 10, 10, 0.08)",
    gold: "oklch(0.72 0.08 80)",
    goldSoft: "oklch(0.86 0.05 80)",
    buttonDark: "#0A0A0A",
    buttonDarkText: "#FBF6EC",
  },
  radius: {
    xs: "12px",
    sm: "16px",
    md: "24px",
    lg: "32px",
    xl: "40px",
    pill: "999px",
  },
  blur: "blur(28px) saturate(180%)",
  blurLight: "blur(20px) saturate(180%)",
  blurStrong: "blur(36px) saturate(200%)",
  shadow: {
    sm: "0 4px 14px -6px rgba(60,40,20,0.18), inset 0 1px 0 rgba(255,255,255,0.9)",
    md: "0 12px 40px -12px rgba(60,40,20,0.18), 0 2px 6px -2px rgba(60,40,20,0.08), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.04)",
    lg: "0 30px 80px -24px rgba(60,40,20,0.30), 0 8px 24px -8px rgba(60,40,20,0.12), inset 0 1px 0 rgba(255,255,255,0.85), inset 0 -1px 0 rgba(0,0,0,0.04)",
    xl: "0 40px 100px -40px rgba(60,40,20,0.35), inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  transition: "all 0.25s ease",
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Inter", system-ui, sans-serif',
} as const;

export const formatMoney = (value?: number) => {
  if (!value) return "$0";
  return `$${value.toLocaleString("es-AR", { maximumFractionDigits: 0 })}`;
};
